import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=6ac91b80&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=6ac91b80&prod&scoped=true&lang=scss&"
import style1 from "./goodsList.vue?vue&type=style&index=1&id=6ac91b80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac91b80",
  null
  
)

export default component.exports